import React from "react";
import { Accordion, Box, Flex, Group, Text, Button } from "@mantine/core";

export const AccordionStylesheet = () => (
  <Accordion mb="md">
    <Accordion.Item value="item1">
      <Accordion.Control>
        <Group>
          <Box w={40}>
            <Text fz="sm">15:04</Text>
          </Box>
          <Text fz="sm" fw={700}>
            GPS- Sensor Disconnected
          </Text>
        </Group>
      </Accordion.Control>
      <Accordion.Panel>
        <Group grow>
          <Text fz="sm" fw={700}>
            Type
          </Text>
          <Text fz="sm">Insiders GPS</Text>
        </Group>
      </Accordion.Panel>
      <Accordion.Panel>
        <Group grow>
          <Text fz="sm" fw={700}>
            Athlete
          </Text>
          <Text fz="sm">Long</Text>
        </Group>
      </Accordion.Panel>
      <Accordion.Panel>
        <Group grow>
          <Text fz="sm" fw={700}>
            ID
          </Text>
          <Text fz="sm">000034</Text>
        </Group>
      </Accordion.Panel>
      <Accordion.Panel>
        <Group grow>
          <Text fz="sm" fw={700}>
            Error
          </Text>
          <Text fz="sm">No reception</Text>
        </Group>
      </Accordion.Panel>
      <Accordion.Panel>
        <Flex w="100%" justify="flex-end" mt="sm" py={"xs"}>
          <Button
            variant="ghost"
            rightSection={<></>}
          >
            {" "}
            Data Source
          </Button>
        </Flex>
      </Accordion.Panel>
    </Accordion.Item>
  </Accordion>
);
